import { getUserHasMondayBoards } from "frontend/api";
import { useFetchWithJotai } from "frontend/hooks/use-fetch-with-jotai";
import useStateValue from "frontend/state/value";
import { atom, useAtomValue } from "jotai";
import { AccountCreatedFromSource } from "shared/datamodel/schemas";
import { isCIM } from "utils/url-utils";

type HasMondayBoards = {
  value?: boolean;
};

const hasMondayBoardsAtom = atom<HasMondayBoards>({});

export function useShowMondayFeatures() {
  const globalState = useStateValue();
  const hasMondayBoards = useAtomValue(hasMondayBoardsAtom);

  if (globalState?.[0]?.user?.accountSource === AccountCreatedFromSource.Monday || isCIM()) {
    return true;
  }

  return hasMondayBoards?.value ?? true;
}

export function useLoadUserHasMondayBoards() {
  const shouldSkipForCIM = isCIM();

  useFetchWithJotai<HasMondayBoards>({
    key: shouldSkipForCIM ? null : "userHasMondayBoards",
    fetchFn: async () => {
      const value = await getUserHasMondayBoards();
      return { value };
    },
    atom: hasMondayBoardsAtom,
  });
}
